import React, { useMemo } from 'react';
import PageHeader from '../../components/PageHeader';
import { FullPageSkeleton } from '../../components/ui/Skeleton';
import { usePortalContent, getCfoAdvisoryPageMeta, getPortalIcon } from '../../portal';

const CFO = () => {
  const { content, loading } = usePortalContent('cfo-advisory');
  const meta = useMemo(() => getCfoAdvisoryPageMeta(content), [content]);
  const PageIcon = getPortalIcon(meta.pageIcon);
  const CardIcon = getPortalIcon(meta.cardIcon);

  if (loading) {
    return <FullPageSkeleton />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        icon={PageIcon}
        title={meta.pageTitle}
        subtitle={meta.pageSubtitle}
      />

      <div className="card p-12 text-center opacity-0 animate-fade-in-up" style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}>
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 transition-transform duration-300 hover:scale-110"
          style={{ background: 'var(--primary-100)' }}
        >
          <CardIcon className="w-10 h-10" style={{ color: 'var(--primary-500)' }} />
        </div>
        <h2 className="page-title mb-3">{meta.cardTitle}</h2>
        <p className="body-text max-w-md mx-auto mb-8">{meta.cardBody}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {meta.featureCards.map((card, index) => {
            const FeatureIcon = getPortalIcon(card.icon);
            return (
              <div
                key={`${card.title}-${index}`}
                className="p-4 rounded-xl bg-gray-50 dark:bg-dark-700 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${200 + index * 100}ms`, animationFillMode: 'forwards' }}
              >
                <FeatureIcon className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--primary-500)' }} />
                <h3 className="card-title mb-1">{card.title}</h3>
                <p className="body-text">{card.description}</p>
              </div>
            );
          })}
        </div>

        {meta.footerNote && (
          <p className="text-sm text-gray-400 dark:text-gray-500 mt-8 opacity-0 animate-fade-in-up" style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}>
            {meta.footerNote}
          </p>
        )}
      </div>
    </div>
  );
};

export default CFO;
